<template>
    <v-dialog :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)" max-width="520">
        <v-card>
            <v-card-title class="d-flex align-center">
                <v-icon class="mr-2">mdi-history</v-icon>
                Storico sostituzioni
            </v-card-title>
            <v-card-text>
                <div v-if="storico.length === 0" class="text-medium-emphasis pa-4 text-center">
                    Nessuno storico disponibile.
                </div>
                <v-timeline v-else density="compact" side="end">
                    <v-timeline-item v-for="c in storico" :key="c.id"
                        :dot-color="c.sostituito ? 'info' : 'success'" size="small">
                        <div class="font-weight-medium">{{ c.nome }}</div>
                        <div class="text-caption text-medium-emphasis">
                            <span v-if="c.dataAcquisto">acquistato il {{ formattaData(c.dataAcquisto) }}</span>
                            <span v-if="c.dataAcquisto"> · </span>
                            <span>{{ c.dataScadenza ? `scadenza ${formattaData(c.dataScadenza)}` : 'nessuna scadenza' }}</span>
                        </div>
                        <v-chip size="small" class="mt-1" :color="c.sostituito ? 'info' : 'success'" variant="flat">
                            {{ c.sostituito ? `sostituito il ${formattaData(c.dataSostituzione)}` : 'Attivo' }}
                        </v-chip>
                    </v-timeline-item>
                </v-timeline>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn variant="text" @click="chiudi">Chiudi</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "DialogStoricoContenuto",

    props: {
        modelValue: { type: Boolean, default: false },
        contenutoId: { type: [Number, String], default: null },
    },
    emits: ["update:modelValue"],

    computed: {
        storico() {
            return this.$store.getters["contenutiSicurezza/storico"];
        },
    },

    watch: {
        modelValue(val) {
            if (val && this.contenutoId) {
                this.$store.dispatch("contenutiSicurezza/caricaStorico", this.contenutoId);
            }
        },
    },

    methods: {
        formattaData(iso) {
            return iso ? new Date(iso).toLocaleDateString("it-IT") : "—";
        },

        chiudi() {
            this.$emit("update:modelValue", false);
        },
    },
};
</script>
